import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";
import { Flex, Box } from "@otrium/core";
import { HyperLink } from "src/atoms/HyperLink";
import { Divider } from "src/atoms/Divider";

const PillarsWrapper = styled(Flex)`
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  border-radius: ${({ theme }) => theme.space[2]}px;
  margin: ${({ theme }) => theme.space[2]}px 0;
  background: ${({ theme }) => theme.colors.tone.sand};
`;

const StyledPillar = styled(Box)`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
  padding: ${({ theme }) => theme.space[3]}px;
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const StyledDivider = styled(Divider)`
  margin: ${({ theme }) => theme.space[3]}px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: ${({ theme }) => theme.space[5]}px 0;
  }
`;

const StyledHyperLink = styled(HyperLink)`
  text-decoration: underline;
  display: inline;
  line-height: inherit;
  text-decoration-thickness: 1px;
  white-space: nowrap;

  &:hover {
    text-decoration-thickness: 1px;
    text-underline-position: unset;
  }
`;

const FaceIconsWrapper = styled(Flex)`
  margin-top: ${({ theme }) => theme.space[2]}px;
  svg {
    margin-right: ${({ theme }) => theme.space[2]}px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: 0;
  }
`;

const CertificationsWrapper = styled(Flex)`
  padding-top: 16px;
  flex-direction: row;
  flex-wrap: wrap;
`;

const CertificationRow = styled(Flex)<{ isRow?: boolean }>`
  flex: 1 1 100%;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: ${({ isRow }) => (isRow ? "1 1 100%" : "1 1 50%")};
    padding-right: ${({ theme, isRow }) => (isRow ? 0 : theme.space[3])}px;
    &:nth-of-type(even) {
      padding-right: 0;
    }

    &:last-of-type,
    &:nth-last-of-type(2) {
      ${({ isRow }) => !isRow && "margin-bottom: 0;"}
    }
  }
`;

const StyledCertificationText = styled(Text)`
  margin-left: ${({ theme }) => theme.space[2]}px;
  &:first-letter {
    text-transform: capitalize;
  }
`;

const ScoreHeader = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export {
  PillarsWrapper,
  StyledDivider,
  StyledPillar,
  StyledHyperLink,
  FaceIconsWrapper,
  CertificationsWrapper,
  CertificationRow,
  StyledCertificationText,
  ScoreHeader,
  IconWrapper,
};
